import {
    SET_LOADING,
    SET_GO_TO_PAGE,
    SET_SELECTED_PROJECT,
    SET_FIRST_TYPE_PORTFOLIO_DATA,
    SET_SECOND_TYPE_PORTFOLIO_DATA,
} from '../actions/actionTypes';

const initialState = {
    page: 0,
    profile: false,
    profile2: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch(type) {
      case SET_FIRST_TYPE_PORTFOLIO_DATA:
          return {
              ...state,
              profile: payload,
          };
      case SET_SECOND_TYPE_PORTFOLIO_DATA:
          return {
              ...state,
              profile2: payload,
          };
      case SET_GO_TO_PAGE:
          return {
            ...state,
            page: payload,
          };
      case SET_LOADING:
          return {
              ...state,
              isLoading: payload,
          };
      case SET_SELECTED_PROJECT:
          return {
            ...state,
            selectedProject: payload,
          };
      default:
          return state;
  }
};

export default reducer;
